import { SelectProps } from "./SelectProps";

// Radio dùng cùng options editor như Select
export const RadioProps = SelectProps;
